module.exports = __webpack_public_path__ + "static/img/Gem.0a4dc37b.png";